import React from 'react';
import ToolbarMenuItem from 'features/toolbar/ToolbarMenuItem/ToolbarMenuItem';
import { ToolbarMenuItemWrapperProps } from 'features/toolbar/types';
import { useLockControl } from 'features/toolbar/toolbar/controls/lock/useLockControl';

const LockControl = ({ onClick }: ToolbarMenuItemWrapperProps) => {
  const { triggerLockConfirmation, icon, label, isFeatureAvailable } = useLockControl();

  if (!isFeatureAvailable) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
    triggerLockConfirmation();
  };

  return (
    <ToolbarMenuItem
      id="lock"
      overlay={label}
      ariaLabel={label}
      icon={icon}
      onClick={handleClick}
    />
  );
};

export default LockControl;
